import React from 'react';
import { useParams } from 'react-router-dom';
import JoinQuiz from './JoinQuiz';

export default function JoinRoom() {
  const { id } = useParams<{ id?: string }>();

  // Show the JoinQuiz form
  return <JoinQuiz />;
}


